import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleModal } from '../../Actions';
const ComponentModalLink = ({ children = null, modalKey, linkText = '', id, name = '', dispatch, classes = '' }) => (_jsx("span", { children: _jsx("button", Object.assign({ onClick: () => dispatch(toggleModal(modalKey, id, name)), className: `${classes} ${children === null ? 'button' : ''}` }, { children: children !== null ? _jsx("span", { dangerouslySetInnerHTML: { __html: children } }) : linkText })) }));
ComponentModalLink.propTypes = {
    modalKey: PropTypes.string.isRequired,
    linkText: PropTypes.string,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    name: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.string,
    classes: PropTypes.string
};
export default connect()(ComponentModalLink);
